import { createFileRoute } from '@tanstack/react-router';
import { CapabilityTier } from '@signalvote/shared';
import { requireCapability } from '@/lib/routeGuards';
import { MatchReview } from '@/components/fundraising';

// The Match review tab: the possible federal matches to answer, largest gift first. Fundraising:Manage —
// the verdict PUT is the Fundraiser's. `?prospect=` (from a prospect page) opens that person first.
export const Route = createFileRoute('/admin/fundraising/match-review')({
  validateSearch: (search: Record<string, unknown>): { prospect?: string } =>
    typeof search.prospect === 'string' && search.prospect !== '' ? { prospect: search.prospect } : {},
  beforeLoad: ({ context }) => {
    requireCapability(context, 'Fundraising', CapabilityTier.Manage, '/admin/fundraising/match-review');
  },
  component: MatchReviewRoute,
});

function MatchReviewRoute() {
  const { prospect } = Route.useSearch();
  return <MatchReview initialProspectId={prospect} />;
}
